__turbopack_context__.v({
  "content": "RelatedAdvisorSection-module__5l25BG__content",
  "image": "RelatedAdvisorSection-module__5l25BG__image",
  "img-container": "RelatedAdvisorSection-module__5l25BG__img-container",
  "items-container": "RelatedAdvisorSection-module__5l25BG__items-container",
  "related-element": "RelatedAdvisorSection-module__5l25BG__related-element",
  "root": "RelatedAdvisorSection-module__5l25BG__root",
  "text": "RelatedAdvisorSection-module__5l25BG__text",
});
